import { generator } from '@philips-emr/tws-core/lib/client/event-listener';

const HPMSOnClickLink = generator('onClickLink');
const HPMSOnClickCheckBox = generator('onClickCheckBox');
const HPMSOnSubmitTermUse = generator('onSubmitTermUse');

export {
  HPMSOnClickLink,
  HPMSOnSubmitTermUse,
  HPMSOnClickCheckBox,
};
